module.exports = __webpack_public_path__ + "img/taza.25ed0779.gif";